import type { ReactElement } from "react";
interface VideoFilePreviewProps {
  file: File;
  submissionId: string | null;
  titleId?: string | null;
  onRemove: () => void;
  onUpload: () => void;
  formatBytes: (bytes: number) => string;
}

/**
 * Video File Preview Component
 */
export function VideoFilePreview({
  file,
  submissionId,
  titleId,
  onRemove,
  onUpload,
  formatBytes,
}: Readonly<VideoFilePreviewProps>): ReactElement {
  const hasId = submissionId || titleId;

  console.log("[VideoFilePreview] Render:", {
    submissionId,
    titleId,
    hasId,
    fileName: file.name,
  });

  return (
    <div className="bg-none border border-neutral-800 rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-white truncate">{file.name}</p>
          <p className="text-xs text-neutral-400">{formatBytes(file.size)}</p>
        </div>
        <button onClick={onRemove} className="ml-4 text-neutral-400 hover:text-white">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <button
        onClick={onUpload}
        disabled={!hasId}
        className="border border-neutral-700 rounded-md bg-transparent text-white hover:bg-amber-900/20 hover:text-lumi-accent hover:border-amber-400/60 focus-visible:text-lumi-accent focus-visible:shadow-none hover:shadow-none px-6 py-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {hasId ? "Start Upload" : "Save first to enable upload"}
      </button>
    </div>
  );
}
